export default __webpack_public_path__ + "66c4cbb701eca623b893959fdd40bc5b.png";